import { useEffect, useState } from "react";
import { Link } from "wouter";
import { listCases } from "@/lib/apiProcedure";
import type { CaseListItem } from "@/types/procedure";

/**
 * File d'attente du greffe : dossiers à traiter (DEPOSE / EN_RECEVABILITE).
 * Le filtrage s'appuie sur `phase_procedurale` exposée par la liste serveur.
 */
export default function GreffeFile() {
  const [dossiers, setDossiers] = useState<CaseListItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let actif = true;
    listCases()
      .then((res) => {
        if (!actif) return;
        const data = Array.isArray(res.data) ? res.data : [];
        setDossiers(
          data.filter(
            (d) =>
              d.phase_procedurale === "DEPOSE" ||
              d.phase_procedurale === "EN_RECEVABILITE",
          ),
        );
      })
      .catch(() => actif && setDossiers([]))
      .finally(() => actif && setLoading(false));
    return () => {
      actif = false;
    };
  }, []);

  if (loading)
    return <div className="p-6 animate-pulse">Chargement de la file…</div>;

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-4">
      <h1 className="text-2xl font-bold text-gray-800">
        File du greffe — Recevabilité
      </h1>

      {dossiers.length === 0 ? (
        <p className="text-gray-500">Aucun dossier en attente.</p>
      ) : (
        <div className="bg-white shadow rounded-lg overflow-hidden">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                  Référence
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                  Phase
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {dossiers.map((d) => (
                <tr key={d.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">
                    {d.reference}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span
                      className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                        d.phase_procedurale === "DEPOSE"
                          ? "bg-yellow-100 text-yellow-800"
                          : "bg-blue-100 text-blue-800"
                      }`}
                    >
                      {d.phase_procedurale}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    <Link
                      href={`/greffe/cases/${d.id}/recevabilite`}
                      className="text-indigo-600 hover:text-indigo-900"
                    >
                      {d.phase_procedurale === "DEPOSE"
                        ? "Prendre en charge"
                        : "Voir recevabilité"}
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
